module.exports = [{"id":"left","title":"Левый руль"},{"id":"rigth","title":"Правый"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/wheels.json
// module id = 1152
// module chunks = 49